import { Autocomplete, Box, Checkbox, Grid, IconButton, Popover, TextField } from '@mui/material';
import { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import PullToRefresh from 'react-simple-pull-to-refresh';
import { ClearConversationHistory, LoadFalkonEsignTemplates, LoadMessages, LoadScheduleMessages, loadSecureChatConversations, LoadSecureFiles, LoadSecureScheduleMessages, UpdateContactsMassActionDeletionStatus, UpdateContactTypes, UpdateMenuFlag } from "../../actions";
import { setHeaderTitle, setRefreshHandler } from '../../helpers/header.helper';
import setToast from '../../helpers/toaster.helper';
import { ArchivedIcon, BackMobileIcon, BlockIcon, BurgerMenuIcon, CancelIcon, CheckboxCheckedIcon, CheckboxDefaultIcon, CheckboxIndeterminateIcon, DisableBlockIcon, FilterListIcon, MultiSelectConvDark, MultiSelectCrossIcon, StackedSquareIcon, TimmerIcon, TrashIcon, UnArchivedIcon } from '../../icon';
import { Contact, ConversationCardModel, ConversationModel, DeliveryStatus, mapToContactType } from '../../models/conversations';
import { ScheduledMessageModel } from '../../models/conversations/schedule-messages.model';
import { OrgPlanTracker, PlanMetrics } from '../../models/plan-metrics.model';
import * as selector from '../../selectors/selectors';
import { ContactService } from '../../services/ContactService';
import { MessageService } from '../../services/MessageService';
import { UtilityService } from '../../services/UtilityService';
import { AppRoutes } from '../routes/route.path';
import ConfirmDialog from "../shared/confirm-dialog.component";
import { ActionLabels, appNote, buttonLabels, ContactsMassAction, ConversationsMassAction, pageTitles, ToasterTexts } from '../shared/constants';
import { ToasterType } from '../shared/toaster/toaster.model';
import BlankConvHistory from './blank-conv-history';
import ConversationHeader from './conversation-header';
import ConversationHistoryComponent from './conversation-history-component';
import { NewMessageIconsComponent } from './newmessage-icon.component';
import SendMessageNew from "./send-message-component";
import { SecureFileModel } from '../../models/secure-file';
import { UserService } from '../../services/UserService';
import ContactInfoComponent from './contact-info.component';
import ContactInfoComponentNew from './contact-info.newcomponent';
import { UserModel } from '../../models/users.model';
import ButtonComponent from '../shared/button/button.component';
import { range, uniqueId } from 'lodash';
import AnimateLoader from "../shared/loaders/animate-loader.component";
import ConversationCardLoaderAminationData from "../shared/loaders/conversations-card-loader.json";
import ConversationCardLoaderAminationDataDark from "../shared/loaders/conversations-card-loader-dark.json";
import ConversationInfiniteList from './conversation-infinite-list.component';
import BlankConvCard from './blank-conversation-tab';

interface Props { }

const CONVERSATION_FILTERS_KEY = "filters";
const SECURE_CHAT_FILTERS_KEY = "secureChatFilters";

const getFiltersStorageKey = (secureChat: boolean) =>
    secureChat ? SECURE_CHAT_FILTERS_KEY : CONVERSATION_FILTERS_KEY;

const readStoredFilterIds = (secureChat: boolean): unknown[] => {
    const key = getFiltersStorageKey(secureChat);
    const primary = localStorage.getItem(key);
    if (primary) {
        try {
            const parsed = JSON.parse(primary);
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            return [];
        }
    }
    return [];
};

const updateStoredFilterIds = (secureChat: boolean, ids: string[]) => {
    const key = getFiltersStorageKey(secureChat);
    if (!ids?.length) {
        localStorage.removeItem(key);
        return;
    }
    localStorage.setItem(key, JSON.stringify(ids));
};

const removeStoredFilters = (secureChat: boolean) => {
    localStorage.removeItem(getFiltersStorageKey(secureChat));
};


const ConversationComponent = (props: Props) => {
    const scrollRef = useRef<any>();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const Conversations: ConversationModel[] = useSelector(selector.conversations);
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);
    const LoadingConversations: boolean = useSelector(selector.loadingConversations);
    const LoadingSecureChatConversations: boolean = useSelector(selector.loadingSecureChatConversations);
    const PlanMetrics: PlanMetrics = useSelector(selector.planMetrics);
    const DeviceHeight: number = useSelector(selector.deviceHeight);
    const ScheduleMessages: ScheduledMessageModel[] = useSelector(selector.scheduleMessages)
    const SecureFiles: SecureFileModel[] = useSelector(selector.secureFiles)
    const OrgPlanTracker: OrgPlanTracker = useSelector(selector.orgPlanTracker)
    const IsNewOrgFlow: boolean = useSelector(selector.isNewOrgFlow)
    const Contacts: Contact[] = useSelector(selector.contacts)
    const Users: UserModel[] = useSelector(selector.users)
    const IsDarkMode: boolean = useSelector(selector.isDarkMode)
    const ShowingAlert: boolean = useSelector(selector.showingAlert)

    const [searchText, setSearchText] = useState<string>("")
    const [convCardsData, setConvCardsData] = useState<ConversationCardModel[]>([])
    const [activeCard, setActiveCard] = useState<ConversationCardModel>()
    const [activeCardIndex, SetActiveCardIndex] = useState<number>(0)
    const [openSendMessage, setOpenSendMessage] = useState<boolean>(false)
    const [isGroupChat, setIsGroupChat] = useState<boolean>(false)
    const [unreadCount, setUnreadCount] = useState<number>(0)
    const [pathName, setPathName] = useState<string>("")
    const [isCampaign, setIsCampaign] = useState<boolean>(false)
    const [selectedConversations, setSelectedConversations] = useState<string[]>([]);
    const [checkedConversations, setCheckedConversations] = useState<ConversationModel[]>([]);
    const [showMultiActionButtons, setShowMultiActionButtons] = useState<boolean>(false);
    const [openMassAction, setOpenMassAction] = useState<boolean>(false);
    const [text, setText] = useState<string>("");
    const [buttonName, setButtonName] = useState<string>("");
    const [action, setAction] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const IsMassDeletionInProgress: boolean = useSelector(selector.isMassDeletionInProgress)
    const [showDeleteDialog, setShowDeleteDialog] = useState<boolean>(false)
    const [value, setValue] = useState("Active");
    const [editSchedule, setEditSchedule] = useState<boolean>(false)
    const [OperatingScheduledMessage, setOperatingScheduledMessage] = useState<ScheduledMessageModel>();
    const { state } = useLocation();
    const [contactState, setContactState] = useState<Contact>(state)
    const [isDuplicate, setIsDuplicate] = useState<boolean>(false)
    const [participantId, setParticipantID] = useState<string>("")

    const isSecureChat = location.pathname.includes("secure-chat")

    const SecureChatConversations: ConversationModel[] = useSelector(selector.secureChatConversations);

    const SecureChatScheduleMessages: any[] = useSelector(selector.SecureChatScheduleMessages);

    const [conversations, setConversations] = useState(location.pathname.includes("secure-chat") ? SecureChatConversations : Conversations)
    const [showAnchorElFilter, setShowAnchorElFilter] = useState<Element | null>(null)
    const [showCheckboxes, setShowCheckboxes] = useState<boolean>(false);
    const [isScrollable, setIsScrollable] = useState(false);
    const [allFilters, setAllFilters] = useState<{
        Id: number,
        CategoryLabel: string,
        MultiSelection?: boolean,
        Options: {
            Label: string,
            Selected: boolean,
            Icon?: any,
            Id?: string | number,
            Hide?: boolean
        }[]
    }[]>(UtilityService.getConversationFilterModel(Users))

    //contact info component 
    const [showContactInfo, setShowContactInfo] = useState(false);
    const [contactInfoData, setContactInfoData] = useState<any>(null);

    const tabs = useMemo(() => { return isSecureChat ? ["Active", "Unread", "Archived", "All"] : ["Active", "Unread", "Archived"] }, [isSecureChat])

    const handleShowContactInfo = (data?: any) => {
        setContactInfoData(data || null);
        setShowContactInfo(true);
    };

    const handleCloseContactInfo = () => {
        setShowContactInfo(false);
        setContactInfoData(null);
    };

    const handleEditScheduleChange = (value, id?: any) => {
        setEditSchedule(value);
        if (isSecureChat && id) {
            const selectedSchedule = SecureChatScheduleMessages?.find(x => x.ID === id)
            setOperatingScheduledMessage({ ...selectedSchedule, Type: selectedSchedule?.ScheduleType, NextScheduledDateTime: selectedSchedule?.MessageDateTime, EndDateTime: selectedSchedule?.EndDateTime })
        }
        if (!isSecureChat) {
            setOperatingScheduledMessage(ScheduleMessages?.find((x) => x.ID === id))
        }
    };

    const handleDuplicateSchedule = (scheduleID: string, ParticipantId: string) => {

        setEditSchedule(true);
        setIsDuplicate(true)
        setParticipantID(ParticipantId)

        if (isSecureChat && scheduleID) {
            const selectedSchedule = SecureChatScheduleMessages?.find(x => x.ID === scheduleID)
            setOperatingScheduledMessage({ ...selectedSchedule, Type: selectedSchedule?.ScheduleType, NextScheduledDateTime: selectedSchedule?.MessageDateTime, EndDateTime: selectedSchedule?.EndDateTime, PhoneNumbers: [selectedSchedule.PhoneNumber] })
        }

    }

    const CloseDialog = () => {
        if (editSchedule) {
            handleEditScheduleChange(false)
            setIsDuplicate(false)
            setParticipantID("")
        }
    }

    useEffect(() => {
        if (location.pathname.includes("secure-chat")) {
            setConversations(SecureChatConversations)
        }
        else {
            setConversations(Conversations)
        }
    }, [Conversations, SecureChatConversations])

    useEffect(() => {
        // setConvCardsData(conversations.map(data => ({ ...data, IsActive: data.PhoneNumber === activeCard?.PhoneNumber ? true : false })))
        handleFilterConversationInitialRender()
    }, [conversations])

    useEffect(() => {
        if (contactState) {
            setOpenSendMessage(true)
        }
    }, [contactState])

    useEffect(() => {
        setHeaderTitle(isSecureChat ? `Secure Chat` : pageTitles.CONVERSATIONS)
        // if (!isSecureChat) {
        //     LoadTemplates(dispatch);
        // }
        setRefreshHandler(refreshHandler)

        if (ScheduleMessages.length === 0 && !isSecureChat) {
            LoadScheduleMessages(dispatch)
        }
        if (!SecureFiles?.length && !isSecureChat) {
            LoadSecureFiles(dispatch, { "user_id": UserService.getCurrentUserId() });
        }

        if (isSecureChat && !SecureChatScheduleMessages?.length) {
            LoadSecureScheduleMessages(dispatch)
        }
        return () => { setHeaderTitle() }

    }, [])

    const refreshHandler = () => {
        if (isSecureChat) {
            loadSecureChatConversations(dispatch);
            LoadSecureScheduleMessages(dispatch)
            ClearConversationHistory(dispatch);
            navigate(AppRoutes.SECURE_CONVERSATIONS)
        }
        else {
            LoadMessages(dispatch);
            ClearConversationHistory(dispatch);
            setShowMultiActionButtons(false);
            setSelectedConversations([]);
        }
    }

    const handleSearch = (value: string) => {
        setSearchText(value)
    }

    const toggleCardActive = (data: ConversationCardModel, index: number) => {
        if (IsMobileDevice) {
            clearSelection()
        }
        let id = !!data?.Campaign?.ID ? data.Campaign.ID : data?.GroupChat ? data?.GroupChat?.ID : UtilityService.unmaskPhoneNumber(data?.PhoneNumber)
        SetActiveCardIndex(index)
        setUnreadCount(data?.GroupChat ? data?.GroupChat?.UnReadCount : data?.UnReadCount)

        navigate(isSecureChat ? `${AppRoutes.SECURE_CONVERSATIONS}/${id}` : `${AppRoutes.CONVERSATIONS}/${id}`)
        let convCardData = convCardsData
        if (activeCard?.PhoneNumber !== id) {
            convCardData = convCardData.map(x => {
                return {
                    ...x,
                    IsActive: !!x.Campaign?.ID ? x.Campaign?.ID === id : !!x.GroupChat?.ID ? x.GroupChat?.ID === id : UtilityService.unmaskPhoneNumber(x.PhoneNumber) === UtilityService.unmaskPhoneNumber(id)

                }
            })
            setActiveCard(convCardData.find(x => x.IsActive))
            setConvCardsData([...convCardData])
        }
    }

    const backHandler = () => {
        navigate(isSecureChat ? AppRoutes.SECURE_CONVERSATIONS : AppRoutes.CONVERSATIONS)
        setActiveCard(undefined);
        if (!!selectedConversations?.length)
            setSelectedConversations([]);
        setShowMultiActionButtons(false);
        // LoadMessages(dispatch);
        ClearConversationHistory(dispatch);
        // navigate(AppRoutes.CONVERSATIONS)
    }
    const handleOpenNewMessage = () => {
        setOpenSendMessage(true)
        setIsGroupChat(false)
        setIsCampaign(false)
    }

    const handleOpenGroupChat = () => {
        setOpenSendMessage(true)
        setIsGroupChat(true)
        setIsCampaign(false)
    }

    const handleOpenCampaign = () => {
        setOpenSendMessage(true)
        setIsGroupChat(false)
        setIsCampaign(true)
    }

    const handleCloseSendMessage = () => {
        setContactState(null)
        setOpenSendMessage(false)
        setIsGroupChat(false)
        setIsCampaign(false)
    }
    // Conversation Tabs
    // const conversationTabs = useMemo(() => {
    //     return [
    //         //     {
    //         //     id: 1,
    //         //     label: "",
    //         //     value: "SelectAllTab",
    //         //     isLoading: false,
    //         //     data: [],
    //         //     hide: isSecureChat
    //         // },
    //         {
    //             id: 2,
    //             label: "Active",
    //             value: "ActiveTab",
    //             isLoading: isSecureChat ? LoadingSecureChatConversations : LoadingConversations,
    //             data: convCardsData.filter(x => x.PhoneNumber?.replace("+", '').includes(searchText) || x.Campaign?.Name?.toLowerCase().includes(searchText.toLowerCase()) || x.GroupChat?.Name?.toLowerCase().includes(searchText.toLowerCase()) || x.Message?.toLowerCase().includes(searchText.toLowerCase()) || x.Contact?.Name.toLowerCase().includes(searchText.toLowerCase())).filter(x => !x.IsArchived),
    //             emptyMessage: "You don't have any active messages"
    //         }, {
    //             id: 3,
    //             label: "Unread",
    //             value: "UnreadTab",
    //             isLoading: isSecureChat ? LoadingSecureChatConversations : LoadingConversations,
    //             data: convCardsData.filter(x => x.PhoneNumber?.replace("+", '').includes(searchText) || x.GroupChat?.Name?.toLowerCase().includes(searchText.toLowerCase()) || x.Message?.toLowerCase().includes(searchText.toLowerCase()) || x.Contact?.Name.toLowerCase().includes(searchText.toLowerCase())).filter(x => !!x.GroupChat ? x.GroupChat?.UnReadCount : x.UnReadCount > 0),
    //             emptyMessage: "You don't have any unread messages"
    //         }, {
    //             id: 4,
    //             label: <div className='p-relative'>
    //                 {
    //                     !!Conversations.filter(x => x.IsArchived).filter(x => !!x.UnReadCount)?.length && <div className=' bg-color-conv-unread-badge br-5 p-absolute' style={{ right: -5, width: "12px", height: "12px", bottom: "10px" }}></div>
    //                 }
    //                 <div>Archived</div>
    //             </div>,
    //             value: "ArchivedTab",
    //             isLoading: isSecureChat ? LoadingSecureChatConversations : LoadingConversations,
    //             data: convCardsData.filter(x => x.PhoneNumber?.replace("+", '').includes(searchText) || x.Campaign?.Name?.toLowerCase().includes(searchText.toLowerCase()) || x.GroupChat?.Name?.toLowerCase().includes(searchText.toLowerCase()) || x.Message?.toLowerCase().includes(searchText.toLowerCase()) || x.Contact?.Name.toLowerCase().includes(searchText.toLowerCase())).filter(x => x.IsArchived),
    //             hide: isSecureChat,
    //             emptyMessage: "You don't have any archived messages"
    //         },
    //         // {
    //         //     id: 5,
    //         //     label: "All",
    //         //     value: "AllTab",
    //         //     isLoading: isSecureChat ? LoadingSecureChatConversations : LoadingConversations,
    //         //     data: convCardsData.filter(x => x.PhoneNumber?.replace("+", '').includes(searchText) || x.Campaign?.Name?.toLowerCase().includes(searchText.toLowerCase()) || x.GroupChat?.Name?.toLowerCase().includes(searchText.toLowerCase()) || x.Message?.toLowerCase().includes(searchText.toLowerCase()) || x.Contact?.Name.toLowerCase().includes(searchText.toLowerCase())),
    //         //     hide: isSecureChat
    //         // },
    //         {
    //             id: 5,
    //             label: <div><FilterListIcon className='w-3 h-3' onClick={(event) => setShowAnchorElFilter(event.currentTarget)} color={JSON.parse(localStorage.getItem("filters") || "[]")?.length > 0 ? "blue" : ""} /></div>,
    //             value: "FilterTab",
    //             isLoading: false,
    //             data: convCardsData.filter(x => x.PhoneNumber?.replace("+", '').includes(searchText) || x.Campaign?.Name?.toLowerCase().includes(searchText.toLowerCase()) || x.GroupChat?.Name?.toLowerCase().includes(searchText.toLowerCase()) || x.Message?.toLowerCase().includes(searchText.toLowerCase()) || x.Contact?.Name.toLowerCase().includes(searchText.toLowerCase())),
    //             hide: isSecureChat,
    //             emptyMessage: "No conversations match your selected filters.",
    //         }
    //     ]
    // }, [convCardsData, searchText])


    useLayoutEffect(() => {
        setPathName(location.pathname)
    }, [location.pathname]);

    useEffect(() => {
        let pathName = location.pathname
        let number = pathName.slice(pathName.lastIndexOf("/") + 1, pathName.length)
        const activeCard = conversations.map(data => ({ ...data, IsActive: false })).find(x => (!!x.Campaign ? x.Campaign.ID : !!x.GroupChat ? x.GroupChat.ID : x.PhoneNumber.replace("+", "")) === number)
        // setConvCardsData(conversations.map(data => ({ ...data, IsActive: data.PhoneNumber === activeCard?.PhoneNumber ? true : false })))
        setActiveCard(activeCard)
        handleFilterConversationInitialRender()
    }, [location.pathname, conversations])

    // const isDisabled = () => {
    //     return !!activeCard?.GroupChat
    //         ? PlanMetrics.GroupCreditsUsage.UsedCredits >= PlanMetrics.GroupCreditsUsage.TotalCredits && PlanMetrics.GroupCreditsUsage.PlanCredits !== -1
    //         : !!activeCard?.IsBlocked && PlanMetrics.NormalTextingUsage.UsedCredits >= PlanMetrics.NormalTextingUsage.TotalCredits && PlanMetrics.NormalTextingUsage.PlanCredits !== -1
    // }

    const isDisabled = () => {
        let isdisabled = true;

        isdisabled = IsNewOrgFlow
            ? !!activeCard?.GroupChat
                ? (OrgPlanTracker.GroupMsgCredits.Used >= (OrgPlanTracker.GroupMsgCredits.Total + OrgPlanTracker.GroupMsgCredits.AddOns)) && OrgPlanTracker.GroupMsgCredits.Total !== -1
                : false
            : !!activeCard?.IsBlocked && PlanMetrics.NormalTextingUsage.UsedCredits >= PlanMetrics.NormalTextingUsage.TotalCredits && PlanMetrics.NormalTextingUsage.PlanCredits !== -1

        return isdisabled
    }

    useEffect(() => {
        if (selectedConversations.length === 0) {
            setShowMultiActionButtons(false)
        } else {
            setShowMultiActionButtons(true)
            setShowCheckboxes(true)
        }
    }, [selectedConversations])

    useEffect(() => {
        if (!IsMassDeletionInProgress) {
            setCheckedConversations([])
            setShowMultiActionButtons(false)
        }
    }, [IsMassDeletionInProgress])

    const handleShowMultiActionButtons = (status: boolean) => {
        setShowMultiActionButtons(status);
        setSelectedConversations([]);
        setShowCheckboxes(false)
    }

    const handleConversationSelect = (id: ConversationCardModel) => {
        let ID = !!id?.Campaign?.ID ? id.CampaignId : id?.GroupChat ? id.GroupChat.ID : UtilityService.unmaskPhoneNumber(id.PhoneNumber);
        if (selectedConversations.includes(ID)) {
            setSelectedConversations(selectedConversations.filter((id) => id !== ID));
        } else {
            setSelectedConversations([...selectedConversations, ID]);
        }
    };

    useEffect(() => {
        const selectedIdSet = new Set(selectedConversations);
        const filteredConversations = conversations.filter(convo => {
            const id = !!convo?.Campaign?.ID ? convo.CampaignId : convo?.GroupChat?.ID || UtilityService.unmaskPhoneNumber(convo.PhoneNumber);
            return selectedIdSet.has(id);
        });
        setCheckedConversations(filteredConversations);
    }, [conversations, selectedConversations]);

    const determineType = (id: string) => {
        if (Conversations.some(c => c.GroupChat?.ID === id)) return 2;
        if (Conversations.some(c => c.CampaignId === id)) return 3;
        return 1;
    };

    const openMassActionConfirmDialog = (action: string) => {
        let text;
        switch (action) {
            case ConversationsMassAction.BLOCK:
                text = appNote.MASS_ACTION_TEXT
                    .replace('<action>', ConversationsMassAction.BLOCK)
                    .replace('<name>', checkedConversations.length > 1 ? pageTitles.CONVERSATIONS.toLocaleLowerCase() : ConversationsMassAction.CONVERSATION);
                setAction("blockContacts")
                break;
            case ConversationsMassAction.UNBLOCK:
                text = appNote.MASS_ACTION_TEXT
                    .replace('<action>', ConversationsMassAction.UNBLOCK)
                    .replace('<name>', checkedConversations.length > 1 ? pageTitles.CONVERSATIONS.toLocaleLowerCase() : ConversationsMassAction.CONVERSATION);
                setAction("unblockContacts")
                break;
            default:
                text = "";
                break;
        }
        setOpenMassAction(true);
        setText(text);
        setButtonName(action);
        setIsLoading(false);
    }

    const closeMassActionConfirmDialog = async (isConfirm: boolean) => {
        if (!!isConfirm) {
            setIsLoading(true);
            let data: any[];
            data = checkedConversations.map(convo => {
                const convoId = !!convo?.Campaign?.ID
                    ? convo.CampaignId
                    : convo?.GroupChat?.ID || convo.PhoneNumber;

                return convoId;
            });

            const MassActioninfo = {
                ButtonName: buttonName,
                selectedConversations: data.length
            }

            await ContactService.contactsMassActionDelete(action, data)
                .then((res) => {
                    localStorage.setItem("contactMassAction", JSON.stringify(MassActioninfo))
                })
                .catch(err => {
                    if (err.response.status === 404 || err.response.status === 400 || err.response.status === 500) {
                        setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
                        setIsLoading(false);
                    }
                    UpdateContactsMassActionDeletionStatus(dispatch, false)
                })

            if (buttonName === ConversationsMassAction.BLOCK) {
                setToast("Attention: Your contacts are currently being blocked in the background. Feel free to continue using the application.", ToasterType.INFO)
            }
            else {
                setToast("Attention: Your contacts are currently being unblocked in the background. Feel free to continue using the application.", ToasterType.INFO)
            }

            setOpenMassAction(false);
            setButtonName("");
            setIsLoading(false);
            setCheckedConversations([]);
            setShowMultiActionButtons(false);
            clearSelection();
            UpdateContactsMassActionDeletionStatus(dispatch, true)

        } else {
            setOpenMassAction(false);
            setButtonName("");
            setIsLoading(false);
        }
    };

    const clearSelection = () => {
        if (!!selectedConversations?.length)
            setSelectedConversations([]);
        setShowMultiActionButtons(false);
    }

    const handleArchiveConversations = async (checkedConversations: ConversationModel[], isArchived: boolean) => {
        let data: any[];
        data = checkedConversations.map(convo => {
            const convoId = !!convo?.Campaign?.ID
                ? convo.CampaignId
                : convo?.GroupChat?.ID || UtilityService.unmaskPhoneNumber(convo.PhoneNumber);

            return convoId;
        });

        return MessageService.conversationsMassActionArchive("archive", !isArchived, data)
            .then((res) => {
                setToast(isArchived ? ToasterTexts.UNARCHIVE_SUCCESS : ToasterTexts.ARCHIVE_SUCCESS, ToasterType.SUCCESS)
                UpdateContactTypes(dispatch, res.map(mapToContactType))
                setCheckedConversations([]);
                setShowMultiActionButtons(false);
                clearSelection();
            })
            .catch(err => { })

    };

    const closeDeleteDialog = async (isConfirm: boolean) => {
        if (isConfirm) {
            setIsLoading(true);
            let data: any[];
            data = checkedConversations.map(convo => {
                const convoId = !!convo?.Campaign?.ID
                    ? convo.CampaignId
                    : convo?.GroupChat?.ID || UtilityService.unmaskPhoneNumber(convo.PhoneNumber);

                return {
                    number: convoId,
                    type: determineType(convoId),
                };
            });

            MessageService.conversationsMassActionDelete("delete", data).then((res) => {
                setShowDeleteDialog(false)
                setCheckedConversations([]);
                setShowMultiActionButtons(false);
                clearSelection();
            }).catch(err => {
                setIsLoading(false);
            })
            setToast("Attention: Your conversations are currently being deleted in the background. Feel free to continue using the application.", ToasterType.INFO)
            refreshHandler()
            setIsLoading(false);

        } else {
            setButtonName("");
            setIsLoading(false);
            setShowDeleteDialog(false)
        }
    };
    const massAction = JSON.parse(localStorage.getItem("contactMassAction"))
    const pullToRefresh = () => new Promise((resolve) => setTimeout(resolve, 15)).then(() => LoadMessages(dispatch))

    const handleFilterClearAll = () => {
        let conversation = conversations.map(data => ({ ...data, IsActive: data.PhoneNumber === activeCard?.PhoneNumber ? true : false })).filter(x => !x.IsArchived)

        const filters = allFilters.map(y => {
            return {
                ...y, Options: y.Options.map(z => { return { ...z, Selected: false } })
            }
        })
        setAllFilters(filters)
        setConvCardsData(conversation)
        removeStoredFilters(isSecureChat)
        setShowAnchorElFilter(null)
        setValue("Active")
    }

    const handleFilterSelect = (SelectedFilters, SelectedLabel, Selected) => {
        const filters = allFilters.map(y => {
            return {
                ...y, Options: y.Options.map(z => { return { ...z, Selected: z.Label === SelectedLabel ? !z.Selected : z.Selected } })
            }
        })
        setAllFilters(filters)
    }

    const handleAssigneeChange = (event, values) => {
        const selectedIds = values.map(v => v.Id);

        const updatedFilters = allFilters.map(x => {
            if (x.CategoryLabel !== "Assignee To") {
                return x;
            }
            return {
                ...x,
                Options: x.Options.map(option => ({
                    ...option,
                    Selected: selectedIds.includes(option.Id)
                }))
            };

        });
        setAllFilters(updatedFilters);
    };

    const handleApplyFilters = (allFilters) => {
        const selected = allFilters.flatMap(x => x.Options).filter(x => x.Selected);

        const selectedLabels = new Set(selected.map(x => x.Label));
        const selectedIds = selected.map(x => x.Id);

        let conversation = conversations.map(data => ({
            ...data,
            IsActive: data.PhoneNumber === activeCard?.PhoneNumber
        }));

        if (selected.length === 0) {
            setConvCardsData(conversation.filter(x => !x.IsArchived));
            setShowAnchorElFilter(null);
            removeStoredFilters(isSecureChat);
            setValue("Active");
            return;
        }

        const typeFilters = [];

        if (selectedLabels.has("1-1")) typeFilters.push("single");
        if (selectedLabels.has("Campaign")) typeFilters.push("campaign");
        if (selectedLabels.has("Group Chat")) typeFilters.push("group");


        const complianceFilters = [];

        if (selectedLabels.has("Unsubscribed")) complianceFilters.push("IsUnsubscribed");
        if (selectedLabels.has("Blocked")) complianceFilters.push("IsBlocked");


        const visibilityFilters = [];

        if (selectedLabels.has("Archived")) visibilityFilters.push("IsArchived");
        if (selectedLabels.has("Pinned")) visibilityFilters.push("IsPinned");
        if (selectedLabels.has("Muted")) visibilityFilters.push("IsMuted");
        if (selectedLabels.has("Unread")) visibilityFilters.push("Unread");


        const assignStatusFilters = allFilters.find(x => x.CategoryLabel === "Assign Status")?.Options.filter(x => x.Selected).map(x => x.Id) || [];


        const assigneeFilters = allFilters.find(x => x.CategoryLabel === "Assignee To")?.Options.filter(x => x.Selected).map(x => x.Id === "unassigned" ? null : x.Id) || [];

        const result = conversation.filter(x => {

            if (typeFilters.length > 0) {

                const isSingle = !x.Campaign?.ID && !x.GroupChat?.ID;
                const isCampaign = !!x.Campaign?.ID;
                const isGroup = !!x.GroupChat?.ID;

                const typeMatch =
                    (typeFilters.includes("single") && isSingle) ||
                    (typeFilters.includes("campaign") && isCampaign) ||
                    (typeFilters.includes("group") && isGroup);

                if (!typeMatch) return false;
            }

            if (complianceFilters.length > 0) {
                if (!complianceFilters.some(key => x[key])) return false;
            }

            if (visibilityFilters.length > 0) {

                const visible = visibilityFilters.some(filter => {

                    if (filter === "Unread") {
                        const unread =
                            x.GroupChat
                                ? x.GroupChat?.UnReadCount
                                : x.UnReadCount;

                        return unread > 0;
                    }

                    return !!x[filter];
                });

                if (!visible) return false;
            }


            if (
                assignStatusFilters.length > 0 &&
                !assignStatusFilters.includes(x.AssignStatus)
            ) {
                return false;
            }

            if (
                assigneeFilters.length > 0 &&
                !assigneeFilters.includes(x.Assignee)
            ) {
                return false;
            }

            return true;
        });
        setConvCardsData(result);
        setShowAnchorElFilter(null);
        // navigate(AppRoutes.CONVERSATIONS)

        if (selectedIds.length === 1) {
            if (selectedIds.includes("archived")) setValue("Archived");
            else if (selectedIds.includes("unread")) setValue("Unread");
            else setValue("");
        } else {
            setValue("");
        }

        updateStoredFilterIds(isSecureChat, selectedIds);
    };

    const handleCancelFilters = () => {
        const localStorageFilters = readStoredFilterIds(isSecureChat);
        if (localStorageFilters?.length > 0) {
            const filters = allFilters.map(x => {
                return {
                    ...x,
                    Options: x.Options.map(option => ({
                        ...option,
                        Selected: localStorageFilters.includes(option.Id)
                    }))
                };

            });
            setAllFilters(filters)
        }
        setShowAnchorElFilter(null)
    }

    const handleSelectAllCheckBoxs = (checked: boolean) => {

        const data = convCardsData.map(c => {
            return !!c?.Campaign?.ID ? c.CampaignId : c?.GroupChat ? c.GroupChat.ID : UtilityService.unmaskPhoneNumber(c.PhoneNumber)
        })

        setSelectedConversations(() => {
            const updatedSelections = checked ? data : [];
            return updatedSelections;
        });
        if (!checked) {
            setShowCheckboxes(false)
        }
    }

    const handleTabChange = (value: string) => {
        setValue(value)
        setShowMultiActionButtons(false)
        setShowCheckboxes(false)
        setSelectedConversations([])
        if (value === "Active") {
            handleFilterClearAll();
            setConvCardsData(conversations.map(data => ({ ...data, IsActive: data.PhoneNumber === activeCard?.PhoneNumber ? true : false }))?.filter(x => !x.IsArchived))
            return
        }
        else if (value === "Archived") {
            setConvCardsData(conversations.map(data => ({ ...data, IsActive: data.PhoneNumber === activeCard?.PhoneNumber ? true : false }))?.filter(x => x.IsArchived))
        }
        else if (value === "All") {
            setConvCardsData(conversations.map(data => ({ ...data, IsActive: data.PhoneNumber === activeCard?.PhoneNumber ? true : false })))
        }
        else {
            setConvCardsData(conversations.map(data => ({ ...data, IsActive: data.PhoneNumber === activeCard?.PhoneNumber ? true : false }))?.filter(x => (x?.GroupChat?.ID ? x.GroupChat?.UnReadCount : x.UnReadCount) > 0))
        }
        const filters = allFilters.map(category => ({
            ...category,
            Options: category.Options.map(option => {
                let selected = option.Selected;
                if (option.Label === value) {
                    selected = true
                }
                else {
                    selected = false
                }
                return {
                    ...option,
                    Selected: selected
                };
            })
        }));
        setAllFilters(filters);
        updateStoredFilterIds(isSecureChat, [value.toLowerCase()])
        // navigate(AppRoutes.CONVERSATIONS);
    }

    const handleFilterConversationInitialRender = () => {
        if (allFilters?.length > 0) {
            const localStorageFilters = readStoredFilterIds(isSecureChat);
            if (localStorageFilters?.length > 0) {
                const filters = allFilters.map(x => {
                    return {
                        ...x,
                        Options: x.Options.map(option => ({
                            ...option,
                            Selected: localStorageFilters.includes(option.Id)
                        }))
                    };

                });
                setAllFilters(filters)
                handleApplyFilters(filters)
                if (localStorageFilters?.length === 1) {
                    if (localStorageFilters.includes("archived")) {
                        setValue("Archived")
                    }
                    if (localStorageFilters.includes("unread")) {
                        setValue("Unread")
                    }
                    if (localStorageFilters.includes("all")) {
                        setValue("All")
                    }
                }
                else {
                    setValue("")
                }
            }
            else {
                setConvCardsData(conversations.map(data => ({ ...data, IsActive: data.PhoneNumber === activeCard?.PhoneNumber ? true : false })).filter(x => !x.IsArchived))
                setValue("Active")
            }
        }
    }

    useEffect(() => {
        const el = scrollRef?.current;
        if (!el) return;
        const checkScroll = () => {
            setIsScrollable(el.scrollHeight > el.clientHeight);
        };

        el.addEventListener("scroll", checkScroll);

        return () => {
            el.removeEventListener("scroll", checkScroll);
        };

    }, [convCardsData]);

    useEffect(() => {
        setAllFilters(UtilityService.getConversationFilterModel(Users))
        handleFilterConversationInitialRender()
    }, [Users]);

    const returnConversationCardData = () => {
        const search = searchText.toLowerCase();
        const cardsdata = convCardsData.filter((x) =>
            x.PhoneNumber?.replace("+", "").includes(search) ||
            x.Campaign?.Name?.toLowerCase().includes(search) ||
            x.GroupChat?.Name?.toLowerCase().includes(search) ||
            x.Message?.toLowerCase().includes(search) ||
            x.Contact?.Name?.toLowerCase().includes(search) ||
            x?.MaskedPhoneNumber?.includes(search)
        );
        // End scroll item
        let endScroll: ConversationCardModel = {
            ID: "endScroll",
            IsArchived: false,
            IsOutbound: false,
            PhoneNumber: "You have reached the end of the scroll",
            MaskedPhoneNumber: "You have reached the end of the scroll",
            Message: "Only displaying the last 365 days. View complete history in ",
            MessageDateTime: new Date().toString(),
            SenderID: "...",
            UnReadCount: 0,
            IsActive: false,
            IsPinned: false,
            IsBlocked: false,
            IsUnsubscribed: false,
            DeliveryStatus: DeliveryStatus.NONE,
            IsMuted: false,
            msgType: isSecureChat ? "secure-chat" : "conversation"
        }

        return isScrollable ? [...cardsdata, endScroll] : cardsdata;
    }

    const conversationCards = useMemo(() => returnConversationCardData(),
        [convCardsData, isSecureChat, searchText, isScrollable]);

    useEffect(() => {
        LoadFalkonEsignTemplates(dispatch, UserService.getCurrentUserOrgId())
    }, [])

    return (
        <div className={`bg-color-primary-background h-p-100 w-p-100 ${IsMobileDevice ? "flex-direction" : "pr-1"} d-flex`}>
            {IsMobileDevice && !activeCard && !openSendMessage && !editSchedule && (
                showMultiActionButtons ?
                    <div className="d-flex justify-between">
                        <span className={`mx-2 my-1 h1 d-flex `}>
                            <BackMobileIcon onClick={() => { backHandler() }} className={"my-auto mr-2"} />
                            <span className="my-auto h3-medium">
                                {selectedConversations.length > 0 ? `${selectedConversations.length} selected` : ''}
                            </span>
                        </span>
                        <span className="d-flex ">
                            <IconButton
                                size="large"
                                aria-label="Show Checkboxes"
                            >
                                <TrashIcon className={`c-pointer`} onClick={() => { setShowDeleteDialog(true) }} />
                            </IconButton>
                            <IconButton
                                size="large"
                                aria-label="Show Checkboxes"
                            >
                                {
                                    (!!checkedConversations?.length && checkedConversations.some(item => item.GroupChat || item.Campaign)) ? (
                                        <DisableBlockIcon />
                                    ) : !(
                                        (!!checkedConversations?.length && checkedConversations.every(item => item.IsBlocked)) ||
                                        (!!checkedConversations?.length && checkedConversations.every(item => !item.IsBlocked))
                                    ) ? (
                                        <DisableBlockIcon />
                                    ) : (
                                        <BlockIcon className={`c-pointer`} onClick={() => { openMassActionConfirmDialog(checkedConversations.every(item => item.IsBlocked) ? ConversationsMassAction.UNBLOCK : ConversationsMassAction.BLOCK) }} />
                                    )
                                }
                            </IconButton>
                            <IconButton
                                size="large"
                                aria-label="Show Checkboxes"
                            >
                                <ArchivedIcon className={`c-pointer`} onClick={() => {
                                    const isArchived = checkedConversations?.every(item => item.IsArchived);
                                    handleArchiveConversations(checkedConversations, isArchived);
                                }} />
                            </IconButton>
                            {/* <MenuItemRender HorizantelIcon={true} ClassName={"d-hover opacity-2"}  MeetBallIcon={SettingsHorizIcon} /> */}

                        </span>
                    </div> :
                    <div className="d-flex">
                        <span className={`mx-2 my-1 h1`}>
                            <BurgerMenuIcon className="mr-1" onClick={(e) => { e.stopPropagation(); UpdateMenuFlag(dispatch, true) }} style={{ marginTop: "0.25rem" }} />
                        </span>
                        <span className="my-auto h1">
                            {isSecureChat ? "Secure chat" : "Conversations"}
                        </span>
                    </div>
            )}
            {((!activeCard && IsMobileDevice && !openSendMessage && !editSchedule) || (!IsMobileDevice)) &&
                <div className={`${IsMobileDevice ? 'w-p-100' : 'min-w-35 w-p-27'}`}>
                    <PullToRefresh isPullable={IsMobileDevice} pullingContent='' onRefresh={pullToRefresh} className='h-fit'>
                        <div className='d-flex flex-direction h-p-100 w-p-100'>
                            <ConversationHeader
                                IsMobileDevice={IsMobileDevice}
                                handleSearch={handleSearch}
                                OnClickNewMessage={handleOpenNewMessage}
                                OnClickNewGroupMessage={() => handleOpenGroupChat()}
                                OnClickNewCampaignMessage={() => handleOpenCampaign()}
                                openSendMessage={openSendMessage}
                                SecureChat={isSecureChat}
                            />
                            {/* <ConversationTabsComponent handleShowMultiActionButtons={handleShowMultiActionButtons} scrollRef={scrollRef} conversationTabs={conversationTabs} DeviceHeight={DeviceHeight} toggleCardActive={toggleCardActive} selectAll={isSelected} indeterminate={isIndeterminate} selectedConversations={selectedConversations} onConversationSelect={handleConversationSelect} onSelectAll={handleSelectAll} tabValue={value} IsSecureChat={isSecureChat} ConversationData={convCardsData} /> */}

                            <div className='d-flex justify-around align-center pt-1'>
                                {!isSecureChat &&
                                    <div> {showCheckboxes ?
                                        <Checkbox
                                            icon={IsDarkMode ? <MultiSelectConvDark /> : <CheckboxDefaultIcon />}
                                            checkedIcon={<CheckboxCheckedIcon />} indeterminateIcon={<CheckboxIndeterminateIcon />}
                                            checked={selectedConversations?.length === convCardsData?.length}
                                            indeterminate={!!selectedConversations?.length && selectedConversations?.length !== convCardsData?.length}
                                            onChange={(e) => handleSelectAllCheckBoxs(e.target.checked)}
                                            inputProps={{ 'aria-label': 'select all conversations' }}
                                            size="small"
                                            className='p-0'
                                        />
                                        : <div onClick={() => setShowCheckboxes(!showCheckboxes)} className={`c-pointer`} >
                                            {IsDarkMode ? <MultiSelectConvDark /> : <StackedSquareIcon />}
                                        </div>}
                                    </div>
                                }
                                {
                                    tabs.map((x, index) =>
                                        <div key={index} className={`${x === value ? "color-primary-light h5-semibold" : "color-primary-accent h5-medium"} c-pointer`} onClick={(e) => handleTabChange(x)}>{x}</div>
                                    )
                                }

                                {!isSecureChat && <div className="c-pointer">
                                    <FilterListIcon className="w-3 h-3"
                                        onClick={(event) => setShowAnchorElFilter(event.currentTarget)}
                                        color={(() => {
                                            const filters = readStoredFilterIds(false);
                                            return filters.length > 0 ?
                                                (filters.length === 1 && (value === "Unread" || value === "Archived"))
                                                    ? "" : "blue" :
                                                "";
                                        })()}
                                    />
                                </div>
                                }

                            </div>
                            <div className="d-flex flex-direction h-v-85 o-y-auto p-0" >
                                {LoadingConversations ? (
                                    range(1, 13).map(() => (
                                        <AnimateLoader
                                            key={uniqueId()}
                                            LoaderAnimation={
                                                IsDarkMode
                                                    ? ConversationCardLoaderAminationDataDark
                                                    : ConversationCardLoaderAminationData
                                            }
                                            className="w-p-100 bb-primary-divider-4"
                                        />
                                    ))
                                ) : conversationCards?.length ? (
                                    <ConversationInfiniteList
                                        handleShowMultiActionButtons={handleShowMultiActionButtons}
                                        scrollRef={scrollRef}
                                        // ConversationCards={isScrollable ? [...convCardsData, endScroll] : props.ConversationData}
                                        ConversationCards={conversationCards}
                                        Height={(ShowingAlert && !IsMobileDevice) ? DeviceHeight - 215 : DeviceHeight - 160}
                                        toggleCardActive={toggleCardActive}
                                        selectedConversations={selectedConversations}
                                        onConversationSelect={handleConversationSelect}
                                        showCheckboxes={showCheckboxes}
                                        showContactInfo={showContactInfo}
                                    />
                                ) : (
                                    <BlankConvCard label={value !== "" ? `You don't have any ${value.toLowerCase()} messages` : "No conversations match your selected filters."} />
                                )}
                            </div>
                        </div>
                    </PullToRefresh>
                </div>
            }
            <div className={`${IsMobileDevice ? "w-p-100" : "conv-hist-border w-p-72"} ${((editSchedule || openSendMessage) && IsMobileDevice) ? "" : "h-p-100"} br-4`}>
                {activeCard && (selectedConversations.length === 0) ?
                    (!IsMobileDevice || (IsMobileDevice && !editSchedule)) && (<ConversationHistoryComponent
                        scrollRef={scrollRef}
                        pathName={pathName}
                        activeCardIndex={activeCardIndex}
                        UnreadCount={unreadCount}
                        BackHandler={backHandler}
                        CardData={activeCard}
                        deviceHeight={DeviceHeight}
                        IsMobileDevice={IsMobileDevice}
                        ActiveCardIndex={activeCardIndex}
                        IsDisabled={isDisabled()}
                        onEditScheduleChange={handleEditScheduleChange}
                        onOpenContactInfo={handleShowContactInfo} // added for contactinfo
                        DuplicateSchedule={handleDuplicateSchedule}
                        onCloseContactInfo={handleCloseContactInfo}
                    />)
                    : (!openSendMessage && !IsMobileDevice) &&
                    <BlankConvHistory
                        SelectedConversationsCount={selectedConversations?.length}
                        ShowMultiActionButtons={showMultiActionButtons}
                        MultiActionButtons={[
                            {
                                Name: ActionLabels.DELETE,
                                Variant: !IsMassDeletionInProgress && !!checkedConversations?.length ? "primary" : "disabled",
                                ClassName: "mr-1",
                                Icon: TrashIcon,
                                OnClick: () => { setShowDeleteDialog(true) }
                            },
                            {
                                Name: (!!checkedConversations?.length && checkedConversations?.every(item => item.IsBlocked)) ? ActionLabels.UNBLOCK : ActionLabels.BLOCK,
                                Variant: !IsMassDeletionInProgress && (!!checkedConversations?.length && checkedConversations.some(item => item.GroupChat || item.Campaign)) ? "disabled"
                                    : ((!!checkedConversations?.length && checkedConversations.every(item => item.IsBlocked)) || (!!checkedConversations?.length && checkedConversations.every(item => !item.IsBlocked))) ? "primary" : "disabled",
                                Hide: !((!!checkedConversations?.length && checkedConversations?.every(item => item.IsBlocked)) || (!!checkedConversations?.length && checkedConversations?.every(item => !item.IsBlocked))),
                                ClassName: "mr-1",
                                Icon: BlockIcon,
                                OnClick: () => openMassActionConfirmDialog(checkedConversations.every(item => item.IsBlocked) ? ConversationsMassAction.UNBLOCK : ConversationsMassAction.BLOCK)
                            },
                            {
                                Name: (!!checkedConversations?.length && checkedConversations?.every(item => item.IsArchived)) ? ActionLabels.UNARCHIVE : ActionLabels.ARCHIVE,
                                Variant: !IsMassDeletionInProgress && !!checkedConversations?.length ? "primary" : "disabled",
                                Hide: !((!!checkedConversations?.length && checkedConversations?.every(item => item.IsArchived)) || (!!checkedConversations?.length && checkedConversations?.every(item => !item.IsArchived))),
                                ClassName: "mr-1",
                                Icon: (!!checkedConversations?.length && checkedConversations?.every(item => item.IsArchived)) ? UnArchivedIcon : ArchivedIcon,
                                OnClick: () => {
                                    const isArchived = checkedConversations?.every(item => item.IsArchived);
                                    handleArchiveConversations(checkedConversations, isArchived);
                                }
                            },
                            {
                                Name: ActionLabels.CLEAR_SELECTION_CONVERSATION,
                                Variant: "text",
                                ClassName: "p-0 mr-1 w-space",
                                Icon: MultiSelectCrossIcon,
                                OnClick: () => clearSelection(),
                            }
                        ]}
                    />}

            </div>
            {showContactInfo && contactInfoData && (<div className={`${IsMobileDevice ? "w-p-100" : " w-p-35 ml-1 mr-1"} ${((editSchedule || openSendMessage) && IsMobileDevice) ? "" : "h-p-98"} br-4`}>
                <ContactInfoComponentNew
                    CardTitle={
                        contactInfoData.Campaign
                            ? pageTitles.CAMPAGIN_CHAT_INFORMATION
                            : contactInfoData.GroupChat
                                ? pageTitles.GROUP_CHAT_INFORMATION
                                : pageTitles.CONTACT_INFO
                    }
                    CloseContactInfo={handleCloseContactInfo}
                    Contact={activeCard?.Contact ?? {
                        PhoneNumber: contactInfoData.PhoneNumber,
                        MaskedPhoneNumber: contactInfoData.MaskedPhoneNumber
                    } as Contact}
                    GroupChatInfo={activeCard?.GroupChat}
                    campaignInfo={activeCard?.Campaign}
                    ActiveCardIndex={activeCardIndex}
                    CardData={activeCard}
                />

            </div>)}
            {IsMassDeletionInProgress && <div className='px-3 h6-semibold my-auto d-flex'> <TimmerIcon className="mr-1" /><div className=''>
                {`Contact ${massAction?.ButtonName === ContactsMassAction.DELETE ? "Deletion" : massAction?.ButtonName === ConversationsMassAction.BLOCK ? "Blocking" : "Unblocking"} In Progress. You can continue using the application while your contacts are being updated.`}</div>
            </div>}
            {
                openMassAction &&
                <ConfirmDialog
                    onClose={closeMassActionConfirmDialog}
                    Show={openMassAction}
                    Text={text}
                    ButtonName={buttonName}
                    IsMobileDevice={IsMobileDevice}
                    Loading={isLoading}
                ></ConfirmDialog>
            }
            {showDeleteDialog &&
                <ConfirmDialog
                    onClose={closeDeleteDialog}
                    Show={showDeleteDialog}
                    Text={appNote.CONVERSATIONS_DELETE}
                    ButtonName={buttonLabels.DELETE}
                    IsMobileDevice={IsMobileDevice}
                    Loading={isLoading}
                />
            }

            {
                !isSecureChat && IsMobileDevice && !activeCard && !openSendMessage && !editSchedule &&
                <div style={{ zIndex: 10000 }}>
                    <NewMessageIconsComponent
                        OnClickNewMessage={handleOpenNewMessage}
                        OnClickNewGroupMessage={handleOpenGroupChat}
                        OnClose={handleCloseSendMessage}
                        OnClickNewCampaignMessage={() => handleOpenCampaign()} />
                </div>
            }

            {
                openSendMessage &&
                <SendMessageNew
                    open={openSendMessage}
                    handleClose={() => handleCloseSendMessage()}
                    IsGroupChat={isGroupChat}
                    IsCampaign={isCampaign}
                    SetIscompaign={(value: boolean) => setIsCampaign(value)}
                    contact={contactState}
                />
            }
            {
                editSchedule &&
                (
                    <SendMessageNew
                        IsSecureChat={isSecureChat}
                        open={editSchedule}
                        isScheduleMsg={true}
                        ContactIDs={[...(OperatingScheduledMessage?.ContactIds ?? []),
                        ...(OperatingScheduledMessage?.PhoneNumbers?.filter(
                            x => Contacts?.some(y => y?.MaskedPhoneNumber?.replace("+", "") === x)
                        ) ?? [])]}
                        GroupIDs={OperatingScheduledMessage?.Groups?.map((x) => x.ID)}
                        Message={OperatingScheduledMessage?.Message}
                        ScheduleType={OperatingScheduledMessage?.Type}
                        ScheduleDateTime={OperatingScheduledMessage?.NextScheduledDateTime}
                        ScheduleEndDateTime={OperatingScheduledMessage?.EndScheduledDateTime}
                        PhoneNumbers={OperatingScheduledMessage?.PhoneNumbers?.filter(x => Contacts?.some(y => y.MaskedPhoneNumber.replace("+", "") !== x))}
                        handleClose={() => handleEditScheduleChange(false)}
                        handleSuccess={() => CloseDialog()}
                        showScheduleType={true}
                        ScheduledMessageID={OperatingScheduledMessage?.ID}
                        // UnsubscribeContactCount={unsubscribeContactsCount(OperatingScheduledMessage?.Groups?.map(x => x.ID))}
                        Campaign={OperatingScheduledMessage?.Campaign?.ID ? OperatingScheduledMessage?.Campaign : undefined}
                        MultiMedia={OperatingScheduledMessage?.Media}
                        IsDuplicate={isDuplicate}
                        ParticipantID={participantId}
                    />
                )
            }
            {Boolean(showAnchorElFilter) && <Popover
                open={Boolean(showAnchorElFilter)}
                onClose={() => setShowAnchorElFilter(null)}
                classes={{ paper: `br-2 ${IsMobileDevice ? "w-42" : "w-50"} box-shadow-primary-header-shadow ${!IsDarkMode ? "bg-color-secondary" : "bg-color-sidebar-bg"} d-flex justify-center align-center` }}
                anchorEl={showAnchorElFilter}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <div>
                    <div className='d-flex justify-between align-center bb-primary-divider-1 align-center w-p-92 mx-auto pt-2'>

                        <div className='d-flex align-center'>
                            <FilterListIcon />
                            <div className='h2-semibold ml-1'>Filters</div>
                        </div>
                        <div className='d-flex'>
                            <div className={` ${allFilters?.flatMap(x => x.Options).filter(x => x.Selected)?.length > 0 ? "color-primary-light" : "color-primary-accent"}  h4-regular c-pointer mr-2`} onClick={() => handleFilterClearAll()}>Clear All</div>
                            <CancelIcon onClick={() => setShowAnchorElFilter(null)} className='c-pointer' />
                        </div>
                    </div>
                    <div className='mt-2 px-2'>
                        <div className='h5-semibold color-login-subtitle'>Assigned To</div>
                        <Autocomplete
                            className='bg-color-sidebar-bg'
                            size='small'
                            multiple
                            getOptionLabel={option => option.Label}
                            renderOption={(defaultprops, option, { selected }) => (
                                <li {...defaultprops} className={`${defaultprops.className} c-pointer h4-regular font-bold p-2 d-flex justify-between ${selected ? 'Mui-focused' : ''}`}>
                                    <div>
                                        {option.Label}
                                    </div>
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder={allFilters?.find(x => x.CategoryLabel === "Assignee To")?.Options?.filter(x => x.Selected)?.length < 1 && 'Search User...'}
                                />
                            )}
                            options={allFilters?.find(x => x.CategoryLabel === "Assignee To")?.Options}
                            onChange={(e, value) => handleAssigneeChange(e, value)}
                            value={allFilters?.find(x => x.CategoryLabel === "Assignee To")?.Options?.filter(x => x.Selected)}
                        />
                    </div>
                    <Grid container className='px-2 bb-primary-divider-4'>
                        {
                            allFilters.filter(x => x.CategoryLabel !== "Assignee To").map(x =>
                                <Grid item md={6} xs={6} xl={6}>
                                    <div className='py-1 '>
                                        <div className='h5-semibold color-con-filter-category-label'>{x.CategoryLabel}</div>
                                        <div className=''>
                                            {x.Options?.filter(x => !x.Hide).map(y =>
                                                <div className=' d-flex align-center'>
                                                    <Checkbox
                                                        className='p-1'
                                                        checked={y.Selected}
                                                        onChange={(e) => handleFilterSelect(x, y.Label, e?.target.checked)}
                                                        icon={
                                                            <Box
                                                                sx={{
                                                                    width: 16,
                                                                    height: 16,
                                                                    border: "1px solid #9fa4b1",
                                                                    borderRadius: "5px",
                                                                }}
                                                            />
                                                        }
                                                        checkedIcon={
                                                            <Box
                                                                sx={{
                                                                    width: 16,
                                                                    height: 16,
                                                                    border: "1px solid #1976d2",
                                                                    borderRadius: "5px",
                                                                    backgroundColor: "#1976d2",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                }}
                                                            >
                                                                <span className='color-lite-dark-white'>✓</span>
                                                            </Box>
                                                        }
                                                    />
                                                    <span className={`${y.Selected ? "h5-semibold" : "h5-regular"}`}>{y.Label}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Grid>
                            )
                        }
                    </Grid>
                    <div className={`${IsDarkMode ? '' : 'bg-color-sidebar-bg'} d-flex justify-flex-end  h-8 align-center`}>
                        <ButtonComponent ButtonLabel={buttonLabels.CANCEL} OnClick={() => handleCancelFilters()} Variant='secondary-btn-small' />
                        <ButtonComponent ButtonLabel={buttonLabels.APPLY} OnClick={() => handleApplyFilters(allFilters)} Variant='primary-btn-small' ClassName='mx-2' />
                    </div>
                </div>
            </Popover>}
        </div >
    )
}

export default ConversationComponent;